import fetch from 'utils/fetch'
// rea
export function getCurrentCVResultsOfReagentManufacturer (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfReagentManufacturer`,
    method: 'post',
    data
  })
}
export function createCVResultsOfReagentManufacturer (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfReagentManufacturer`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfReagentApplication (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfReagentApplication`,
    method: 'post',
    data
  })
}
export function createCVResultsOfReagentApplication (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfReagentApplication`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfReagentTypeAndAddInfoAndValue (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfReagentTypeAndAddInfoAndValue`,
    method: 'post',
    data
  })
}
export function createCVResultsOfReagentTypeAndAddInfoAndValue (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfReagentTypeAndAddInfoAndValue`,
    method: 'post',
    data
  })
}
// exp
export function getCurrentCVResultsOfOmicsTypeAndExpType (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfOmicsTypeAndExpType`,
    method: 'post',
    data
  })
}
export function createCVResultsOfExpType (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfExpType`,
    method: 'post',
    data
  })
}
export function createCVResultsOfOmicsType (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfOmicsType`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfInstrumentManufacturer (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfInstrumentManufacturer`,
    method: 'post',
    data
  })
}

export function createCVResultsOfInstrumentManufacturer (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfInstrumentManufacturer`,
    method: 'post',
    data
  })
}

export function getCurrentCVResultsOfDigestEnzyme (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfDigestEnzyme`,
    method: 'post',
    data
  })
}
export function createCVResultsOfDigestEnzyme (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfDigestEnzyme`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfDigestProtocol (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfDigestProtocol`,
    method: 'post',
    data
  })
}
export function createCVResultsOfDigestProtocol (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfDigestProtocol`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfSeparationMethod (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfSeparationMethod`,
    method: 'post',
    data
  })
}

//sam
export function getCurrentCVResultsOfSampleTissueStatus (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfSampleTissueStatus`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfSampleLocationTypeAndTemperature (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfSampleLocationTypeAndTemperature`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfSampleGenoType (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfSampleGenoType`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfSampleTreatmentTypeAndMethod (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfSampleTreatmentTypeAndMethod`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfSampleCellTypeAndName (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfSampleCellTypeAndName`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfSampleMicroorganismTypeAndName (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfSampleMicroorganismTypeAndName`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfRootAndTaxonSpeciesAndTaxonStrain (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfRootAndTaxonSpeciesAndTaxonStrain`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfRootAndSampleOrganelle (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfRootAndSampleOrganelle`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfRootAndSampleSystemAndOrganAndTissue (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfRootAndSampleSystemAndOrganAndTissue`,
    method: 'post',
    data
  })
}
export function createCVResultsOfRootAndSampleOrganelle (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfRootAndSampleOrganelle`,
    method: 'post',
    data
  })
}
export function createCVResultsOfRootAndTaxonSpeciesAndTaxonStrain (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfRootAndTaxonSpeciesAndTaxonStrain`,
    method: 'post',
    data
  })
}
export function createCVResultsOfSampleGenoType (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfSampleGenoType`,
    method: 'post',
    data
  })
}
export function createCVResultsOfSampleLocationTypeAndTemperature (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfSampleLocationTypeAndTemperature`,
    method: 'post',
    data
  })
}
export function createCVResultsOfSampleTreatmentTypeAndMethod (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfSampleTreatmentTypeAndMethod`,
    method: 'post',
    data
  })
}
export function createCVResultsOfSeparationMethod (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfSeparationMethod`,
    method: 'post',
    data
  })
}
export function createCVResultsOfSampleMicroorganismTypeAndName (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfSampleMicroorganismTypeAndName`,
    method: 'post',
    data
  })
}
export function createCVResultsOfSampleTissueStatus (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfSampleTissueStatus`,
    method: 'post',
    data
  })
}
export function createCVResultsOfSampleCellTypeAndName (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfSampleCellTypeAndName`,
    method: 'post',
    data
  })
}
export function createCVResultsOfRootAndSampleSystemAndOrganAndTissue (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfRootAndSampleSystemAndOrganAndTissue`,
    method: 'post',
    data
  })
}
// common
export function getCurrentCVResultsOfCommonUnitTypeAndUnit (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfCommonUnitTypeAndUnit`,
    method: 'post',
    data
  })
}
export function createCVResultsOfCommonUnitTypeAndUnit (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfCommonUnitTypeAndUnit`,
    method: 'post',
    data
  })
}
//exp ins
export function getCurrentCVResultsOfAnalyzer (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfAnalyzer`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfInstrumentAnalyzerTolerance (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfInstrumentAnalyzerTolerance`,
    method: 'post',
    data
  })
}
export function getCurrentCVResultsOfInstrumentManufacturerAndInstrument (data) {
  return fetch({
    url: `/project/cv/getCurrentCVResultsOfInstrumentManufacturerAndInstrument`,
    method: 'post',
    data
  })
}
export function createCVResultsOfTolerance (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfTolerance`,
    method: 'post',
    data
  })
}
export function createCVResultsOfInstrumentManufacturerAndInstrument (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfInstrumentManufacturerAndInstrument`,
    method: 'post',
    data
  })
}
export function createCVResultsOfAnalyzer (data) {
  return fetch({
    url: `/project/cv/createCVResultsOfAnalyzer`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/cv.js